import type { Provider } from '@app/src/types/organizations'
import { ErrorOutlineOutlined } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import ProvidersMissingWebsite from './ProvidersMissingWebsite'

type WebsiteNotFoundStepProps = {
  providersMissingWebsite: Provider[]
}

const WebsiteNotFoundStep: React.FC<WebsiteNotFoundStepProps> = ({ providersMissingWebsite }) => {
  const { formatMessage } = useIntl()

  return (
    <Stack spacing={3}>
      <Stack direction="row" spacing={1} alignItems="center">
        <ErrorOutlineOutlined sx={{ color: 'semantic.error' }} />
        <Typography fontWeight={600}>
          {formatMessage(
            { id: 'form.scheduleProviderScreening.websiteNotFound.information' },
            { count: providersMissingWebsite.length },
          )}
        </Typography>
      </Stack>

      <Typography color="textSecondary">
        {formatMessage({ id: 'form.scheduleProviderScreening.websiteNotFound.description' })}
      </Typography>

      <ProvidersMissingWebsite providersMissingWebsite={providersMissingWebsite} />
    </Stack>
  )
}

export default WebsiteNotFoundStep
